import { Box, styled } from '@mui/material';

export const DataGridWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  '& div': {
    boxSizing: 'border-box',
  },
  '& svg.sort-icon.active': {
    left: '-3px !important',
  },
  '& > div:nth-child(2)': {
    padding: '0 25px',
  },
}));
